{
  "flags.agents.descr": "The people + agents panzoom canvas at /agents and /team-and-agents.",
  "flags.agents.label": "Team & agents canvas",
  "flags.agentsAssignments.descr": "Assigning agents to people and tasks.",
  "flags.agentsAssignments.label": "Agent assignments",
  "flags.agentsMyAgents.descr": "The agents-only canvas filtered to yours.",
  "flags.agentsMyAgents.label": "My agents view",
  "flags.agentsPermissions.descr": "Per-agent permission chips and scopes.",
  "flags.agentsPermissions.label": "Agent permissions",
  "flags.agentsTools.descr": "Tool grants on each agent profile.",
  "flags.agentsTools.label": "Agent tools",
  "flags.aiAssistant.descr": "The \"Whats up?\" composer, AI answer views, and in-app build flows.",
  "flags.aiAssistant.label": "AI assistant",
  "flags.aiAssistantAnswerViews.descr": "Transient AI-drawn pages you can save as apps.",
  "flags.aiAssistantAnswerViews.label": "AI answer views",
  "flags.aiAssistantBuildApps.descr": "Prompt-to-app builds that land in /add-app.",
  "flags.aiAssistantBuildApps.label": "Build apps with AI",
  "flags.aiAssistantComposer.descr": "The \"Whats up?\" bar docked to every surface.",
  "flags.aiAssistantComposer.label": "Composer bar",
  "flags.aiAssistantModuleAi.descr": "AI operating installed apps (CRM contacts, CMS entries, …).",
  "flags.aiAssistantModuleAi.label": "Module AI actions",
  "flags.aiAssistantPageAwareness.descr": "The assistant sees your current page and data scope.",
  "flags.aiAssistantPageAwareness.label": "Page & data awareness",
  "flags.aiAssistantReasoningTimeline.descr": "The live thinking pill and tool steps above the composer.",
  "flags.aiAssistantReasoningTimeline.label": "Reasoning timeline",
  "flags.aiAssistantSuggestionChips.descr": "Contextual apply-changes chips when idle.",
  "flags.aiAssistantSuggestionChips.label": "Suggestion chips",
  "flags.analytics.descr": "Project + workspace analytics, the live map, and the logs explorer.",
  "flags.analytics.label": "Analytics & logs",
  "flags.analyticsBugsFeed.descr": "AI-analyzed bug events at /logs/bugs.",
  "flags.analyticsBugsFeed.label": "Bugs feed",
  "flags.analyticsLiveMap.descr": "The realtime visitor map.",
  "flags.analyticsLiveMap.label": "Live map",
  "flags.analyticsLogs.descr": "Sessions, events, network, and verbose logs.",
  "flags.analyticsLogs.label": "Logs explorer",
  "flags.analyticsProjectAnalytics.descr": "Per-project traffic and usage dashboards.",
  "flags.analyticsProjectAnalytics.label": "Project analytics",
  "flags.analyticsSessionsExplorer.descr": "Per-session replays and timelines.",
  "flags.analyticsSessionsExplorer.label": "Sessions explorer",
  "flags.analyticsWorkspaceUsage.descr": "Org-level usage rollups.",
  "flags.analyticsWorkspaceUsage.label": "Workspace usage",
  "flags.announcements.descr": "The company blog and posts feed at /announcements.",
  "flags.announcements.label": "Announcements",
  "flags.announcementsPolls.descr": "Polls inside announcement posts.",
  "flags.announcementsPolls.label": "Polls",
  "flags.announcementsTagFilters.descr": "The Product / People / Ops post filters.",
  "flags.announcementsTagFilters.label": "Tag filters",
  "flags.appsSandbox.descr": "Apps built by AI run in an isolated frame that cannot reach your account, storage or the workspace.",
  "flags.appsSandbox.label": "Isolated AI apps",
  "flags.calendar.descr": "Events, bookings, and the mini-calendar rail at /calendar.",
  "flags.calendar.label": "Calendar",
  "flags.calendarAvailability.descr": "Free/busy overlays for teammates.",
  "flags.calendarAvailability.label": "Team availability",
  "flags.calendarBookings.descr": "Bookable slots and scheduling links.",
  "flags.calendarBookings.label": "Bookings",
  "flags.calendarLinkedResources.descr": "Tasks and docs linked onto event cells.",
  "flags.calendarLinkedResources.label": "Linked resources",
  "flags.calendarMiniCalendar.descr": "The month mini-map in the calendar sidebar.",
  "flags.calendarMiniCalendar.label": "Mini calendar rail",
  "flags.calendarMonthWeekViews.descr": "The Month / Week view switcher.",
  "flags.calendarMonthWeekViews.label": "Month & week views",
  "flags.calendarReminders.descr": "Event reminders and nudges.",
  "flags.calendarReminders.label": "Reminders",
  "flags.calendarTeamView.descr": "The cross-member team lane view.",
  "flags.calendarTeamView.label": "Team view",
  "flags.chat.descr": "Channels, DMs, threads, and the floating messenger overlay.",
  "flags.chat.label": "Chat & messenger",
  "flags.chatChannels.descr": "Team channels and their message history.",
  "flags.chatChannels.label": "Channels",
  "flags.chatChatDrawer.descr": "The docked drawer beside the home rail.",
  "flags.chatChatDrawer.label": "Chat drawer",
  "flags.chatDirectMessages.descr": "One-to-one and group DMs.",
  "flags.chatDirectMessages.label": "Direct messages",
  "flags.chatMessengerOverlay.descr": "The floating conversations window on canvas pages.",
  "flags.chatMessengerOverlay.label": "Messenger overlay",
  "flags.chatThreads.descr": "Threaded replies on channel messages.",
  "flags.chatThreads.label": "Threads",
  "flags.communityFeed.descr": "Shared projects, follows, and comments at /feed.",
  "flags.communityFeed.label": "Community feed",
  "flags.communityFeedComments.descr": "Inline comment threads on shared projects.",
  "flags.communityFeedComments.label": "Post comments",
  "flags.communityFeedFollows.descr": "Following creators and the Following filter.",
  "flags.communityFeedFollows.label": "Follows",
  "flags.communityFeedShareComposer.descr": "Posting your public projects to the feed.",
  "flags.communityFeedShareComposer.label": "Share composer",
  "flags.company.descr": "The org overview page at /company.",
  "flags.company.label": "Company page",
  "flags.companyProfileEditing.descr": "Editing the org profile shown at /company.",
  "flags.companyProfileEditing.label": "Company profile editing",
  "flags.customApps.descr": "Your own installed extensions and AI-built apps at /add-app.",
  "flags.customApps.label": "Custom apps",
  "flags.customAppsAiBuilt.descr": "Apps promoted from AI answer views.",
  "flags.customAppsAiBuilt.label": "AI-built apps",
  "flags.customAppsSharing.descr": "Sharing installed apps workspace-wide.",
  "flags.customAppsSharing.label": "App sharing",
  "flags.data.descr": "The admin data surface at /data — users, orgs, projects, plans.",
  "flags.data.label": "Data browser",
  "flags.dataExternalSources.descr": "Connected external datasets at /data/external.",
  "flags.dataExternalSources.label": "External sources",
  "flags.dataOrganizations.descr": "The /data/organizations browser.",
  "flags.dataOrganizations.label": "Organizations table",
  "flags.dataPlans.descr": "The /data/plans and /data/subscriptions browsers.",
  "flags.dataPlans.label": "Plans & subscriptions",
  "flags.dataProjects.descr": "The /data/projects browser.",
  "flags.dataProjects.label": "Projects table",
  "flags.dataTeams.descr": "The /data/teams browser.",
  "flags.dataTeams.label": "Teams table",
  "flags.dataUsers.descr": "The /data/users browser.",
  "flags.dataUsers.label": "Users table",
  "flags.documents.descr": "Docs, notes, and the KB at /notes.",
  "flags.documents.label": "Notes & knowledge base",
  "flags.documentsCollabEditing.descr": "Multiplayer editing on documents.",
  "flags.documentsCollabEditing.label": "Collaborative editing",
  "flags.documentsEditor.descr": "The block editor at /notes/editor.",
  "flags.documentsEditor.label": "Note editor",
  "flags.documentsExportTools.descr": "Exporting docs from the sidebar.",
  "flags.documentsExportTools.label": "Export tools",
  "flags.documentsKnowledgeBase.descr": "The structured KB at /notes/knowledge-base.",
  "flags.documentsKnowledgeBase.label": "Knowledge base",
  "flags.documentsNotes.descr": "Personal and shared notes.",
  "flags.documentsNotes.label": "Notes",
  "flags.files.descr": "The file desktop and folder navigation at /files.",
  "flags.files.label": "Files desktop",
  "flags.filesDesktopGrid.descr": "The icon desktop with drag arrangement.",
  "flags.filesDesktopGrid.label": "Desktop grid",
  "flags.filesFolders.descr": "Folder navigation and the location breadcrumb.",
  "flags.filesFolders.label": "Folders",
  "flags.group.ai.descr": "The assistant, realtime presence, and multitasking chrome.",
  "flags.group.ai.label": "AI & collaboration",
  "flags.group.apps.descr": "Discovering, installing, and building apps on the platform.",
  "flags.group.apps.label": "Marketplace & apps",
  "flags.group.basics.descr": "The foundation every workspace runs on — always on, not switchable.",
  "flags.group.basics.label": "Basics",
  "flags.group.modules.descr": "The built-in apps mounted on workspace routes and navbar tabs.",
  "flags.group.modules.label": "Workspace modules",
  "flags.group.views.descr": "The four org-level lenses the sidebar VIEWS switcher jumps between.",
  "flags.group.views.label": "Canvas views",
  "flags.history.descr": "The workspace activity log as a timeline.",
  "flags.history.label": "History",
  "flags.home.descr": "The signed-in landing at / with its widget grid and app icons.",
  "flags.home.label": "Home dashboard",
  "flags.homeAgentsWidget.descr": "The team-and-agents canvas embedded on the dashboard.",
  "flags.homeAgentsWidget.label": "Agents widget",
  "flags.homeAnalyticsWidget.descr": "Users-today traction card on the dashboard.",
  "flags.homeAnalyticsWidget.label": "Analytics widget",
  "flags.homeAppIcons.descr": "iPad-style app icons that open modules in a window.",
  "flags.homeAppIcons.label": "App icon grid",
  "flags.homeChatRail.descr": "The chat shortcuts column beside the dashboard.",
  "flags.homeChatRail.label": "Channels & DMs rail",
  "flags.homeEventsWidget.descr": "Upcoming calendar events on the dashboard.",
  "flags.homeEventsWidget.label": "Events widget",
  "flags.homeWidgets.descr": "The widget grid and customize mode on the home canvas.",
  "flags.homeWidgets.label": "Dashboard widgets",
  "flags.infra.descr": "Services, environments, and deploy status at /infra.",
  "flags.infra.label": "Infra",
  "flags.infraEnvironments.descr": "Dev / staging / production environment lanes.",
  "flags.infraEnvironments.label": "Environments",
  "flags.infraServicesList.descr": "The services rail with health per service.",
  "flags.infraServicesList.label": "Services list",
  "flags.infraStatusPage.descr": "The service status panel at /infra/status.",
  "flags.infraStatusPage.label": "Status page",
  "flags.mail.descr": "The built-in email client — personal and shared mailboxes from Google Workspace, Gmail, Microsoft 365 and Outlook.",
  "flags.mail.label": "Mail",
  "flags.marketplace.descr": "The catalog of templates, libraries, integrations, and workspace apps.",
  "flags.marketplace.label": "Marketplace",
  "flags.marketplaceDetailGallery.descr": "The App-Store screenshot gallery in item details.",
  "flags.marketplaceDetailGallery.label": "Detail gallery",
  "flags.marketplaceFeatured.descr": "The editorial Featured strips on the catalog.",
  "flags.marketplaceFeatured.label": "Featured rails",
  "flags.marketplaceLivePreviews.descr": "The in-modal live iframe preview of projects.",
  "flags.marketplaceLivePreviews.label": "Live previews",
  "flags.meet.descr": "Calls, rooms, transcripts, and guest invites at /meet.",
  "flags.meet.label": "Meet",
  "flags.meetGuestLinks.descr": "Unauthenticated guests joining via invite URL.",
  "flags.meetGuestLinks.label": "Guest invite links",
  "flags.meetLiveCaptions.descr": "On-screen captions during calls.",
  "flags.meetLiveCaptions.label": "Live captions",
  "flags.meetRooms.descr": "Persistent rooms with in-progress indicators.",
  "flags.meetRooms.label": "Rooms",
  "flags.meetTranscripts.descr": "Live transcription and post-call transcripts.",
  "flags.meetTranscripts.label": "Transcripts",
  "flags.multiWorkspace.descr": "Working across several workspaces via /w/<org> prefixed routes.",
  "flags.multiWorkspace.label": "Multi-workspace tabs",
  "flags.multiWorkspaceOrgSwitcher.descr": "Switching organizations from the header menu.",
  "flags.multiWorkspaceOrgSwitcher.label": "Org switcher",
  "flags.multiWorkspaceWorkspaceUrls.descr": "The /w/<org> prefix that scopes routes per workspace.",
  "flags.multiWorkspaceWorkspaceUrls.label": "Workspace URLs",
  "flags.notifications.descr": "Cross-app notification feed and unread indicators.",
  "flags.notifications.label": "Notifications",
  "flags.notificationsFeed.descr": "The bell dropdown with cross-app notifications.",
  "flags.notificationsFeed.label": "Notification feed",
  "flags.notificationsUnreadBadges.descr": "Unread counters on navbar icons and module tabs.",
  "flags.notificationsUnreadBadges.label": "Unread badges",
  "flags.people.descr": "Team roster at /people — members, roles, and profiles.",
  "flags.people.label": "People directory",
  "flags.peopleInvites.descr": "Inviting new members from the header and people page.",
  "flags.peopleInvites.label": "Invites",
  "flags.peopleMemberProfiles.descr": "Rich profile overlay with HR fields and working hours.",
  "flags.peopleMemberProfiles.label": "Member profiles",
  "flags.peopleRoleManagement.descr": "Changing member roles from person cards.",
  "flags.peopleRoleManagement.label": "Role management",
  "flags.profile.descr": "Your own profile, account settings, and session management.",
  "flags.profile.label": "Profile & account",
  "flags.promptGallery.descr": "Curated prompt collection at /marketplace/prompt-gallery.",
  "flags.promptGallery.label": "Prompt gallery",
  "flags.promptGalleryCopyActions.descr": "One-click copy on prompt cards.",
  "flags.promptGalleryCopyActions.label": "Copy actions",
  "flags.realtime.descr": "Live cursors, presence dots, and collaborative editing sessions.",
  "flags.realtime.label": "Realtime presence & collab",
  "flags.realtimeCollabSessions.descr": "Shared cursors and co-editing sessions.",
  "flags.realtimeCollabSessions.label": "Live collab sessions",
  "flags.realtimeOnlineDock.descr": "The bottom-left dock of members currently online.",
  "flags.realtimeOnlineDock.label": "Online members dock",
  "flags.realtimePresence.descr": "Online dots and live member status.",
  "flags.realtimePresence.label": "Presence indicators",
  "flags.reminders.descr": "Personal reminders and follow-ups.",
  "flags.reminders.label": "Reminders",
  "flags.resolutions.descr": "Customer requests and PR-like resolutions at /resolutions.",
  "flags.resolutions.label": "Resolutions & requests",
  "flags.resolutionsAudit.descr": "The audit trail across requests.",
  "flags.resolutionsAudit.label": "Requests audit",
  "flags.resolutionsEditRequests.descr": "Proposed edits awaiting review.",
  "flags.resolutionsEditRequests.label": "Edit requests",
  "flags.resolutionsImprovements.descr": "The improvements queue.",
  "flags.resolutionsImprovements.label": "Improvements",
  "flags.resolutionsRequests.descr": "Inbound/outbound request queues.",
  "flags.resolutionsRequests.label": "Customer requests",
  "flags.search.descr": "Global search across everything plus the apps launcher dropdown.",
  "flags.search.label": "Search & app launcher",
  "flags.searchAppsLauncher.descr": "The app-picker dropdown on the navbar search.",
  "flags.searchAppsLauncher.label": "Apps launcher",
  "flags.searchCommandSearch.descr": "Search across projects, people, tasks, and docs.",
  "flags.searchCommandSearch.label": "Global search",
  "flags.searchHeaderMorph.descr": "The tabs-to-searchbar morph in the header pill.",
  "flags.searchHeaderMorph.label": "Header search morph",
  "flags.shell.descr": "App navbar, routing, the workspace/org switcher, and page chrome.",
  "flags.shell.label": "Workspace shell & navigation",
  "flags.shellContextMenus.descr": "The global context menu on files, chat, and canvas surfaces.",
  "flags.shellContextMenus.label": "Right-click menus",
  "flags.shellKeyboardShortcuts.descr": "Keyflows and shortcut chords across the shell.",
  "flags.shellKeyboardShortcuts.label": "Keyboard shortcuts",
  "flags.shellModuleTabs.descr": "Installed module tabs (Tasks, Files, CMS, …) in the top navbar.",
  "flags.shellModuleTabs.label": "Navbar module tabs",
  "flags.splitView.descr": "Opening pages in the PageSlot sheet, iPad-style split panes, fullscreen.",
  "flags.splitView.label": "Split view & app windows",
  "flags.splitViewAppWindows.descr": "Opening pages as sheets in the PageSlot.",
  "flags.splitViewAppWindows.label": "App windows",
  "flags.splitViewFullscreenMode.descr": "Edge-to-edge expansion of the open pane.",
  "flags.splitViewFullscreenMode.label": "Fullscreen mode",
  "flags.splitViewPageRestore.descr": "Reopening the last app window after reload (?page=).",
  "flags.splitViewPageRestore.label": "Reload restore",
  "flags.splitViewSplitPane.descr": "iPad-style side-by-side app panes.",
  "flags.splitViewSplitPane.label": "Split panes",
  "flags.studio.descr": "The project canvas at /studio: boards, project tiles, and the editor.",
  "flags.studio.label": "Apps — frontend canvas",
  "flags.studioCanvasSidebars.descr": "The floating left rails on canvas pages.",
  "flags.studioCanvasSidebars.label": "Canvas sidebars",
  "flags.studioProjectCreation.descr": "Creating new projects from the Apps canvas.",
  "flags.studioProjectCreation.label": "Project creation",
  "flags.studioProjectThumbnails.descr": "Screenshot covers on project tiles.",
  "flags.studioProjectThumbnails.label": "Project thumbnails",
  "flags.studioStudiosBoards.descr": "Multi-project canvas boards at /studio/<board>.",
  "flags.studioStudiosBoards.label": "Apps boards",
  "flags.tasks.descr": "The tasks kanban at /tasks — planning, filters, releases, roadmap.",
  "flags.tasks.label": "Tasks board",
  "flags.tasksFeatures.descr": "Feature epics at /tasks/epics.",
  "flags.tasksFeatures.label": "Features",
  "flags.tasksFeed.descr": "The activity stream at /tasks/feed.",
  "flags.tasksFeed.label": "Tasks feed",
  "flags.tasksGeneralTriage.descr": "The cross-workspace triage queue at /tasks/general.",
  "flags.tasksGeneralTriage.label": "General triage",
  "flags.tasksGithubSync.descr": "Two-way issue sync with GitHub repositories.",
  "flags.tasksGithubSync.label": "GitHub sync",
  "flags.tasksMyView.descr": "The Me filter — only tasks assigned to you.",
  "flags.tasksMyView.label": "My view",
  "flags.tasksPlanning.descr": "Status, Release, and Roadmap under PLANNING.",
  "flags.tasksPlanning.label": "Planning pages",
  "flags.tasksStandups.descr": "Daily standup entries alongside the board.",
  "flags.tasksStandups.label": "Standups",
  "flags.tasksTeamAgentLenses.descr": "The All / Team / Agents board lenses.",
  "flags.tasksTeamAgentLenses.label": "Team & agent lenses",
  "flags.tasksTypeFilters.descr": "Sidebar filters by issue type, assignee, and issuer.",
  "flags.tasksTypeFilters.label": "Type & assignee filters",
  "flags.theme.descr": "Theme switching, synced with your system preference.",
  "flags.theme.label": "Dark & light theme",
  "flags.themeSystemSync.descr": "Follow the OS light/dark preference automatically.",
  "flags.themeSystemSync.label": "Sync with system",
  "flags.themeWorkspaceSkins.descr": "Per-workspace design-system overrides from modules.",
  "flags.themeWorkspaceSkins.label": "Workspace skins",
  "flags.workspaceApps.descr": "Installable full apps — CRM, HR, Commerce, Scheduling, CMS, Financials.",
  "flags.workspaceApps.label": "Workspace apps",
  "flags.workspaceAppsCms.descr": "Content collections and publishing.",
  "flags.workspaceAppsCms.label": "CMS",
  "flags.workspaceAppsCommerce.descr": "Invoices and payments.",
  "flags.workspaceAppsCommerce.label": "Commerce",
  "flags.workspaceAppsCrm.descr": "Contacts and companies over the workspace directory.",
  "flags.workspaceAppsCrm.label": "CRM",
  "flags.workspaceAppsFinancials.descr": "Cap table, grants, and valuations.",
  "flags.workspaceAppsFinancials.label": "Financials",
  "flags.workspaceAppsHr.descr": "Team roster, roles, and reporting lines.",
  "flags.workspaceAppsHr.label": "HR",
  "flags.workspaceAppsScheduling.descr": "Bookings and appointments.",
  "flags.workspaceAppsScheduling.label": "Scheduling"
}
